import { render, staticRenderFns } from "./TemplatesIndex.vue?vue&type=template&id=d01a5610&scoped=true"
import script from "./TemplatesIndex.vue?vue&type=script&lang=js"
export * from "./TemplatesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01a5610",
  null
  
)

export default component.exports